import { render, staticRenderFns } from "./MLogoList.vue?vue&type=template&id=4fa45bb6&"
import script from "./MLogoList.ts?vue&type=script&lang=ts&"
export * from "./MLogoList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports